module.exports = __webpack_public_path__ + "assets/img/37_1537_big.3dcce27a.jpg";